<template>
  <div>
    <tsoft-table
      :name="'order-supplier-requests-report'"
      :api="tableApiUrl"
      :items.sync="items"
      :headerContextMenuName="'orderSupplierRequestsReportTable'"
      :isNeedSearch="true"
      :isNeedCreate="false"
      :isNeedSelection="false"
      :onDataEmptyMessage="'Запросы поставщикам на котировку отсутствуют'"
    />
  </div>
</template>

<script>
import { API_ORDER_SUPPLIER } from '@/constants';
import { defaultDataItems } from '@/mixins';

export default {
  mixins: [
      defaultDataItems,
  ],  
  data() {
    return {
      tableApiUrl: API_ORDER_SUPPLIER,
      items: {},
      isLoaded: false,
    };
  },
  methods: {
  },
  mounted() {
  },
};
</script>
